/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniV3LoanRouter,
  UniV3LoanRouterInterface,
} from "../UniV3LoanRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISwapRouter",
        name: "_uniswapV3Router",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "MAX_UINT256",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "sales",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "borrow",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "borrowMax",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV3Router",
    outputs: [
      {
        internalType: "contract ISwapRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniV3LoanRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniV3LoanRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniV3LoanRouter__factory extends ContractFactory {
  constructor(...args: UniV3LoanRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _uniswapV3Router: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniV3LoanRouter> {
    return super.deploy(
      _uniswapV3Router,
      overrides || {}
    ) as Promise<UniV3LoanRouter>;
  }
  getDeployTransaction(
    _uniswapV3Router: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_uniswapV3Router, overrides || {});
  }
  attach(address: string): UniV3LoanRouter {
    return super.attach(address) as UniV3LoanRouter;
  }
  connect(signer: Signer): UniV3LoanRouter__factory {
    return super.connect(signer) as UniV3LoanRouter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniV3LoanRouterInterface {
    return new utils.Interface(_abi) as UniV3LoanRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniV3LoanRouter {
    return new Contract(address, _abi, signerOrProvider) as UniV3LoanRouter;
  }
}
